import { Box, Divider } from '@mui/material'
import React from 'react'
import './Home.css'
import Img1 from '../../../../assets/Help/img1.avif'
import TodaySales from '../../../../assets/Help/todaySales.webp'
import MachineStatus from '../../../../assets/Help/machineStatus.webp'
import SalesAnalysis from '../../../../assets/Help/salesAnalysis.webp'
import Inventorylevel from '../../../../assets/Help/inventorylevel.webp'
import Maintenance from '../../../../assets/Help/maintenance.webp'
import Tax from '../../../../assets/Help/tax.webp'
import Map from '../../../../assets/Help/map.webp'

import { useThemeContext } from '../../../../Context/ThemeContext.js';
import { DARKCOLORS, LIGHTCOLORS } from '../../../../Utils/constants.js';
import { useTranslation } from 'react-i18next';



const Home = () => {
    const { mode } = useThemeContext();
    const { t } = useTranslation();

    const containerBG = mode === 'dark' ? DARKCOLORS.BackgroundMenu : LIGHTCOLORS.BackgroundMenu;
    const subtitletext = mode === 'dark' ? DARKCOLORS.GreyScale60 : LIGHTCOLORS.GreyScale60;
    // const titletext = mode === 'dark' ? DARKCOLORS. : LIGHTCOLORS.GreyScale10;
    const headingcolor = mode === 'dark' ? DARKCOLORS.HeadingLightBackground : LIGHTCOLORS.HeadingLightBackground;


    return (
        <div className='home-container '
        // style={{ backgroundColor: containerBG }} 
        >

            <Box>
                <h1 className='home-title'>{t('help.homeTitle')}</h1>
                <p style={{
                    color: subtitletext
                }} className='home-subtitle'> {t('help.homesubTitle')}</p>
                <p className='home-keyFeature-text'>{t('help.keyfeatures')}</p>
            </Box>
            <Divider className='divider' style={{ marginTop: '10px', marginBottom: '20px' }} />

            <Box className='navigation-container-sec'>
                <ol className='  navigation-ol-list counter-reset-section'>
                    <Box className=' structure-li-outer  img-nav'>

                        {/* Main Item (Should be 1) */}
                        <li className="home-Navi-bar-text structure-p"
                            style={{
                                marginTop: '25px',
                                marginBottom: '20px',
                                color: subtitletext
                            }}>
                            <span style={{ color: headingcolor }} className="number-structure home-Section">
                                {t('help.navigationabar')}
                            </span>
                            <span style={{}}>
                            {t('help.navigationabarText')} </span>
                            {/* Nested List (Should be 1.1, 1.2, etc.) */}
                            <ol className="sec-1 list">
                                <li className="nav-tex-div">
                                    <p style={{ color: headingcolor, marginRight: '10px' }} className="home-Subsection number-structure">
                                        {t('help.sidebarIcon')}
                                    </p>
                                    {t('help.sidebarIconText')}
                                </li>
                                <li className="nav-tex-div ">
                                    <p style={{ color: headingcolor, marginRight: '10px' }} className="home-Subsection number-structure">
                                        {t('help.themeIcons')}
                                    </p>
                                    {t('help.themeIconsText')}
                                </li>
                                <li className="nav-tex-div ">
                                    <p style={{ color: headingcolor, marginRight: '10px' }} className="home-Subsection number-structure">
                                        {t('help.notificationIcon')}
                                    </p>
                                    {t('help.notificationIconText')}
                                </li>
                                <li className="nav-tex-div ">
                                    <p style={{ color: headingcolor, marginRight: '10px' }} className="home-Subsection number-structure">
                                        {t('help.profileDropdown')}
                                    </p>
                                    {t('help.profileDropdownText')}
                                </li>

                                {/* Another Nested List (Should be 1.4.1, 1.4.2, etc.) */}
                                <ol className="sec-4 list">
                                    <li className="nav-tex-div">
                                        <p style={{ color: headingcolor, marginRight: '10px' }} className="number-structure">
                                            {t('help.profilePic')}
                                        </p>
                                        {t('help.profilePicText')}
                                    </li>
                                    <li className="nav-tex-div">
                                        <p style={{ color: headingcolor, marginRight: '10px' }} className="number-structure">
                                            {t('help.general')}
                                        </p>
                                        {t('help.generalText')}
                                    </li>
                                    <li className="nav-tex-div">
                                        <p style={{ color: headingcolor, marginRight: '10px' }} className="number-structure">
                                            {t('help.settings')}
                                        </p>
                                        {t('help.settingsText')}
                                    </li>
                                    <li className="nav-tex-div">
                                        <p style={{ color: headingcolor, marginRight: '10px' }} className="number-structure">
                                            {t('help.logOut')}
                                        </p>
                                        {t('help.logOutText')}
                                    </li>
                                </ol>
                            </ol>
                        </li>
                        <Box className='nav-svg-sec'>
                            <img style={{ width: '100%', maxHeight: '500px', backgroundColor: 'white', borderRadius: '10px' }} src={Img1} alt="Navigation Bar" />
                        </Box>
                    </Box>
                    <Divider className='divider' style={{ marginTop: '50px', marginBottom: '50px' }} />

                    <Box className='today-sales-sec structure-li-outer'>
                        <Box className=' nav-sec-div number-align'>
                            <li className='home-Navi-bar-text spac1'  > <span className='number-structure'>{t('help.TodaysSales')}</span> </li>
                            <p style={{
                                color: subtitletext
                            }} className='home-Navi-bar-text' >{t('help.TodaysSalesText')}</p>
                        </Box>
                        <Box className='nav-svg-sec'>
                            <img style={{
                                maxHeight: '400px', // update this to 400px by harsha
                                marginTop: '12px',
                            }} src={TodaySales} alt="Todays-Sales" />
                        </Box>
                    </Box>
                    <Divider className='divider' style={{ marginTop: '50px', marginBottom: '50px' }} />
                    <Box className='today-sales-sec structure-li-outer'>
                        <Box className='nav-sec-div number-align ' >

                            <li className='home-Navi-bar-text spac1  ' > <span className='number-structure'>{t('help.salesAnalysis')}</span> </li>
                            <p style={{
                                color: subtitletext
                            }} className='home-Navi-bar-text' > {t('help.salesAnalysisText')}</p>
                        </Box>
                        <Box className='nav-svg-sec'>
                            <img style={{
                                maxHeight: '500px',
                                marginTop: '12px',
                                width: '100%',
                            }} src={SalesAnalysis} alt="Todays-Sales" />
                        </Box>
                    </Box>
                    <Divider className='divider' style={{ marginTop: '50px', marginBottom: '50px' }} />
                    <Box className='today-sales-sec structure-li-outer'>
                        <Box className=' nav-sec-div number-align ' >
                            <li className='home-Navi-bar-text spac1' > <span className='number-structure'>{t('help.inventoryLevel')}</span> </li>
                            <p style={{
                                color: subtitletext
                            }} className='home-Navi-bar-text' >{t('help.inventoryLevelText')}</p>
                        </Box>
                        <Box className='nav-svg-sec' >
                            <img className='inventory-level' style={{
                                width: '80%', maxHeight: '320px',
                                marginTop: '12px',
                            }} src={Inventorylevel} alt="Todays-Sales" />
                        </Box>
                    </Box>
                    <Divider className='divider' style={{ marginTop: '50px', marginBottom: '50px' }} />

                    <Box className='today-sales-sec structure-li-outer'>
                        <Box className=' nav-sec-div number-align ' >
                            <li className='home-Navi-bar-text spac1' > <span className='number-structure'>{t('help.machinestatus')}</span> </li>
                            <p style={{
                                color: subtitletext
                            }} className='home-Navi-bar-text' >{t('help.machinestatustext')}</p>
                        </Box>
                        <Box className='nav-svg-sec' >
                            <img style={{
                                width: '80%',
                                marginTop: '12px', maxHeight: '500px',
                            }} src={MachineStatus} alt="Todays-Sales" />
                        </Box>
                    </Box>
                    <Divider className='divider' style={{ marginTop: '50px', marginBottom: '50px' }} />

                    <Box className='today-sales-sec structure-li-outer'>
                        <Box className=' nav-sec-div number-align '  >
                            <li className='home-Navi-bar-text spac1' > <span className='number-structure'>{t('help.maintenanceDisplay')}</span> </li>
                            <p style={{
                                color: subtitletext
                            }} className='home-Navi-bar-text' >{t('help.maintenancetext')}</p>
                        </Box>
                        <Box className='nav-svg-sec' >
                            <img style={{
                                width: '80%',
                                marginTop: '12px', maxHeight: '500px',
                            }} src={Maintenance} alt="Todays-Sales" />
                        </Box>
                    </Box>
                    <Divider className='divider' style={{ marginTop: '50px', marginBottom: '50px' }} />

                    <Box className='today-sales-sec structure-li-outer'>
                        <Box className=' nav-sec-div number-align '  >
                            <li className='home-Navi-bar-text spac1' > <span className='number-structure'>{t('help.taxDisplay')}</span> </li>
                            <p style={{
                                color: subtitletext
                            }} className='home-Navi-bar-text' >{t('help.taxtext')}</p>
                        </Box>
                        <Box className='nav-svg-sec'
                        >
                            <img style={{
                                width: '80%',
                                marginTop: '12px', maxHeight: '500px',
                            }} src={Tax} alt="Todays-Sales" />
                        </Box>
                    </Box>


                    <Divider className='divider' style={{ marginTop: '50px', marginBottom: '50px' }} />

                    <Box className='today-sales-sec  structure-li-outer' sx={{ marginBottom: '50px' }}>
                        <Box className=' nav-sec-div number-align ' >
                            <li className='home-Navi-bar-text spac1' > <span className='number-structure'> {t('help.map')}</span> </li>
                            <p style={{
                                color: subtitletext
                            }} className='home-Navi-bar-text' >{t('help.maptext')}</p>
                        </Box>
                        <Box className='nav-svg-sec' >
                            <img style={{
                                width: '80%', maxHeight: '500px',
                                marginTop: '12px',
                            }} src={Map} alt="Todays-Sales" />
                        </Box>
                    </Box>
                </ol>
            </Box>
            {/* 2 */}
        </div>
    )
}

export default Home